<template>
  <div>
    <ts-card>
      <ts-card-wrapper>
        <h1 class="page-header">
          {{
            $t('school.academic.operation.profile_mgt.teacher_profile.schedule')
          }}
        </h1>
        <div class="row">
          <div class="col-md-12">
            <ts-table
              :columns="columns"
              :records="resources"
              :loading="loading"
            >
              <template slot-scope="{ record }">
                <td>{{ record.schedule_time }}</td>
                <td style="text-align: center; width: 13%;">
                  <div v-show="hasClass(record.Monday)">
                    <span class="font-bold text-primary"
                      >{{ record.Monday.class_name }}
                      {{ record.Monday.room_name }}</span
                    ><br />
                    <span>{{ record.Monday.subject }}</span>
                  </div>
                </td>
                <td style="text-align: center; width: 13%;">
                  <div v-show="hasClass(record.Tuesday)">
                    <span class="font-bold text-primary"
                      >{{ record.Tuesday.class_name }}
                      {{ record.Tuesday.room_name }}</span
                    ><br />
                    <span>{{ record.Tuesday.subject }}</span>
                  </div>
                </td>
                <td style="text-align: center; width: 13%;">
                  <div v-show="hasClass(record.Wednesday)">
                    <span class="font-bold text-primary"
                      >{{ record.Wednesday.class_name }}
                      {{ record.Wednesday.room_name }}</span
                    ><br />
                    <span>{{ record.Wednesday.subject }}</span>
                  </div>
                </td>
                <td style="text-align: center; width: 13%;">
                  <div v-show="hasClass(record.Thursday)">
                    <span class="font-bold text-primary"
                      >{{ record.Thursday.class_name }}
                      {{ record.Thursday.room_name }}</span
                    ><br />
                    <span>{{ record.Thursday.subject }}</span>
                  </div>
                </td>
                <td style="text-align: center; width: 13%;">
                  <div v-show="hasClass(record.Friday)">
                    <span class="font-bold text-primary"
                      >{{ record.Friday.class_name }}
                      {{ record.Friday.room_name }}</span
                    ><br />
                    <span>{{ record.Friday.subject }}</span>
                  </div>
                </td>
                <td style="text-align: center; width: 13%;">
                  <div v-show="hasClass(record.Saturday)">
                    <span class="font-bold text-primary"
                      >{{ record.Saturday.class_name }}
                      {{ record.Saturday.room_name }}</span
                    ><br />
                    <span>{{ record.Saturday.subject }}</span>
                  </div>
                </td>
              </template>
            </ts-table>
          </div>
        </div>
        <div class="row mt-4">
          <div class="col-md-12 text-right">
            <ts-button @click.prevent="$emit('close')">
              {{ $t('close') }}
            </ts-button>
          </div>
        </div>
      </ts-card-wrapper>
    </ts-card>
  </div>
</template>
<script>
export default {
  name: 'schedule',
  props: {
    teacher: {
      type: Object
    }
  },
  data() {
    return {
      resources: [],
      loading: false
    }
  },
  created() {
    this.getSchedule()
  },
  computed: {
    columns() {
      return [
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.teacher_profile.time'
          )
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.teacher_profile.monday'
          )
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.teacher_profile.tuesday'
          )
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.teacher_profile.wednesday'
          )
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.teacher_profile.thursday'
          )
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.teacher_profile.friday'
          )
        },
        {
          name: this.$t(
            'school.academic.operation.profile_mgt.teacher_profile.saturday'
          )
        }
      ]
    }
  },
  methods: {
    getSchedule() {
      this.loading = true
      this.$store
        .dispatch('teacherProfile/schedule', this.teacher.teacher_id)
        .then(response => {
          this.loading = false
          let schedules = response.data
          schedules.forEach(schedule => {
            for (let prop in schedule) {
              let parsedJson = this.tryParseJSON(schedule[prop])
              if (!parsedJson) continue
              schedule[prop] = parsedJson
            }
          })
          this.resources = schedules
        })
        .catch(error => {
          this.loading = false
          this.$emit('close')
          this.$toasted.error(error.message)
        })
    },
    hasClass: () => o => {
      return !isEmpty(o)
    },
    tryParseJSON(jsonString) {
      try {
        let o = JSON.parse(jsonString)

        if (o && typeof o === 'object') {
          return o
        }
      } catch (e) {}

      return false
    }
  }
}
</script>
<style lang="css" scoped>
.font-bold {
	font-weight: bold
}
</style>
